export default "__VITE_ASSET__COPVX$Dc__"